<template>
  <div>
    <van-nav-bar
      :title="$t('app.risk_control.title')"
      :left-text="$t('app.common.back')"
      left-arrow
      @click-left="$router.push('/member/members')"

    />
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="$t('app.common.finished')"
      @load="getList"
    >
      <van-cell v-for="(item,index) in list" :title="$getDeviceTime(item.time)" :key="index">
        <template #label>
          <div class="label-html" v-html="translateSystemKeys(item.detail)"></div>
        </template>
      </van-cell>
    </van-list>

  </div>
</template>

<script>
  export default {
    name: "RiskControl",
    data(){
      return{
        list:[],
        loading:false,
        finished:false,
        page:1
      }
    },
    methods:{
      translateSystemKeys(detail) {
        if (!detail) return "";

        // Replace any system.* key with its i18n value
        return detail.replace(/system\.[\w.]+/g, (match) => {
          return this.$t(match);
        });
      },
      isLogin(){
        let that = this;
        if (!that.$store.state.loginType){
          that.$router.push('/login')
        }
      },
      getList(){
        let that = this;
        let page = that.page;
        that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "risk_control",
              num: 20,
              page: page,
              token: sessionStorage.getItem("token"),
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              let list = that.list;
              that.page = page + 1;
              that.list = list.concat(res.data.data);
              that.loading = false;
              if (res.data.data.length < 20){
                that.finished = true;
              }
            } else if (res.data.code == 0) {
              that.$toast.fail(that.$t(res.data.msg));
            }
          })
          .catch(() => {
            that.loading = false;
            that.finished = true;
        });
      }
    },
    mounted:function () {
      this.isLogin();
      // let page = this.page;
      // this.getList(page)
    },
  }
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/RiskControl.vue